import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { FetchIsEligibleForPlanUpgrade } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const isEligibleForPlanUpgradeSlice = createAsyncThunk(
	'get/isEligibleForPlanUpgradeSlice',
	FetchIsEligibleForPlanUpgrade,
);

export const IsEligibleForPlanUpgradeSlice = createSlice({
	name: 'isEligibleForPlanUpgradeSlice',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[isEligibleForPlanUpgradeSlice.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[isEligibleForPlanUpgradeSlice.rejected.toString()]: setAPIError,
		[isEligibleForPlanUpgradeSlice.fulfilled.toString()]: (
			state: ReturnType<typeof INITIAL_STATE>,
			action: IAPI_ACTION<any>,
		) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = action.payload;
		},
	},
});

interface IStates {
	[IsEligibleForPlanUpgradeSlice.name]: ReturnType<typeof IsEligibleForPlanUpgradeSlice.reducer>;
}

export const isEligibleForPlanUpgradeSelector = (state: IStates): any => {
	return state[IsEligibleForPlanUpgradeSlice.name] || {};
};

export const useIsEligibleForPlanUpgrade = (): any => useSelector(isEligibleForPlanUpgradeSelector);

export const getIsEligibleForPlanUpgrade =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(isEligibleForPlanUpgradeSlice());
		return;
	};

export const resetIsEligibleForPlanUpgrade =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(IsEligibleForPlanUpgradeSlice.actions.RESET());
		return;
	};
